import styled from 'styled-components';

import { theme } from '../../../global';

export const Description = styled.p`
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 19.5px;
  color: ${theme.colors.font_light};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  button {
    height: 56px;
  }
`;
